import { AlertProvider } from './context/alert';
import AppRoutes from './routes';

function App() {
  return (
    <AlertProvider>
      <AppRoutes />
    </AlertProvider>
  );
}

export default App;
